import {useState,useEffect} from 'react'
import { Tooltip } from '@mui/material';
import {  ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import {AiOutlineEdit,AiOutlineDelete} from 'react-icons/ai'
import { Modal } from 'antd';
import moment from 'moment';
import { DeleteClassRoomService, GetClassRoomService } from '../../../services/admin/ClassRoomServices';
import { BsArrowRepeat } from 'react-icons/bs'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { IconButton } from '@mui/material'
import { DatePicker, Select } from 'antd'
import dayjs from 'dayjs'

function ClassRoomList() {


  const initialFilters = {
        search: '',
        from_date: '',
        to_date: ''
    }

    const [data,setdata] = useState([])
    const [selecteddata,setselecteddata] = useState({})
    const [modal, setModal] = useState(false);
    const [page, setpage] = useState(1);
    const [filters, setfilters] = useState(initialFilters)
    const navigate = useNavigate()
    const [appliedFilters, setappliedFilters] = useState(initialFilters)



  
    useEffect(()=>{
        getData()
    },[page, appliedFilters.search, appliedFilters.from_date, appliedFilters.to_date])

    
    

  
  async function getData(){
   const response = await GetClassRoomService(page,appliedFilters.search,appliedFilters.from_date,appliedFilters.to_date)
   setdata(response.data.datas)
  }  

  async function deleteclassRoom(){
    const response = await DeleteClassRoomService(selecteddata._id)
    if(response.status === 200){
        setModal(false)
        toast.success(response.data.datas)
        getData()
    }
  }

  function handleFilterChange(value, field) {
      setfilters((prev) => ({ ...prev, [field]: value || '' }))
    }

     function applyFilters() {
        setpage(1)
        setappliedFilters(filters)
    }

    function resetFilters() {
        setpage(1)
        setfilters(initialFilters)
        setappliedFilters(initialFilters)
    }

  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
   
     <Modal
        keepMounted
        open={modal}
        onClose={()=>setModal(false)}
        width={300}
        footer={false}
        closable={false}
       
      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            {/* <div className='mr-1 w-full'> */}
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setModal(false)} />
            {/* </div> */}
            <div  className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Confirm'} onClick={()=>deleteclassRoom()}  /> 
            </div>
          </div>
        </div>
      </Modal>
        
      <div className='block sm:flex'>
        <SettingsMenu />

        <div className='md:w-[88%] px-4'>
        <div >
        <div className='pt-5'>
        <div className="flex justify-between align-center items-center border-b pb-2 ">
        <span className="font-[800] text-[14px]">Class Room List ({data?.length})</span>


        
        <div className='flex items-center gap-2'> 
        <div className='flex flex-wrap items-center gap-2'>
             <h6 className='mr-2 text-[12px] font-[500]'>
                                        {page === 1 ? (data?.datas?.length > 0 ? 1 : 0) : (((page - 1) * (data?.pagination?.limit || 0)) + 1)} - {Math.min(page * (data?.pagination?.limit || 0), data?.pagination?.total || 0)} of {data?.pagination?.total || 0}
                                    </h6>
          <IconButton onClick={resetFilters}><BsArrowRepeat size={16} /></IconButton>
                                    <div>
                                        <IconButton onClick={() => { if (page > 1) setpage(page - 1) }}>
                                            <FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} />
                                        </IconButton>
                                        <IconButton onClick={() => { if (page < (data?.pagination?.totalPages || 1)) setpage(page + 1) }}>
                                            <FiChevronRight className={`${data?.pagination?.totalPages === page || !data?.pagination?.totalPages ? 'opacity-50' : 'opacity-100'}`} size={16} />
                                        </IconButton>
                                    </div>
                                <input
                                    value={filters.search}
                                    type='text'
                                    placeholder='Search Chapter'
                                    onChange={(event) => handleFilterChange(event.target.value, 'search')}
                                    className='w-full md:w-[150px] border text-sm py-[4px] focus:ring-0 focus:outline-0 text-[13px] px-2 rounded-md border-slate-300'
                                />

                                <DatePicker
                                    size='small'
                                    format='YYYY-MM-DD'
                                    allowClear
                                    placeholder='From Date'
                                    value={filters.from_date ? dayjs(filters.from_date) : null}
                                    onChange={(_, dateString) => handleFilterChange(dateString, 'from_date')}
                                    className='subject-list-date-picker h-[30px] w-full md:w-[140px] border-slate-300 mr-0'
                                />

                                <DatePicker
                                    size='small'
                                    format='YYYY-MM-DD'
                                    allowClear
                                    placeholder='To Date'
                                    value={filters.to_date ? dayjs(filters.to_date) : null}
                                    onChange={(_, dateString) => handleFilterChange(dateString, 'to_date')}
                                    className='subject-list-date-picker h-[30px] w-full md:w-[140px] border-slate-300 mr-0'
                                />
                                
         </div>
                                 <ButtonOutlinedAutoWidth btnName='Apply Filter' onClick={applyFilters} />
                                <ButtonOutlinedAutoWidth btnName='Reset' onClick={resetFilters} />
                                <ButtonFilledAutoWidth btnName='Add Chapter' onClick={() => navigate('create')} />
          </div>
        </div>
        </div>

        {data?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data added based on your current page option please click on add the data button to see list here.</h6>
      </div>
       }


        {data?.length > 0 &&
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-2 mt-2'>
            {data?.map((d,i)=>(
            <div key={d?.id}  className='border items-center relative justify-between px-2 py-1 border-b'>
                <h6 className='text-[13px] font-[400] '>Name : <b>{d.name}</b></h6>
                <h6 className='text-[12px] font-[400] '>Label : <b>{d.label}</b></h6>
                <h6 className='text-[10px] font-[400] bg-slate-100 mt-2 p-1'>Created At : <span className='text-[10px] font-[600] leading-normal'>{moment(d.createdAt).format('LLL')}</span> </h6>
                <div className='absolute right-1 bg-white top-1.5 flex'>
                <Tooltip title="Edit" >
                 <span><AiOutlineEdit size={14} className="cursor-pointer" onClick={()=>{navigate('edit',{state:d})}}/></span>
                </Tooltip>
                <Tooltip title="Delete">
                 <span><AiOutlineDelete size={14} className='ml-2 cursor-pointer'  onClick={()=>{setselecteddata(d);setModal(true)}}/></span>
                </Tooltip>
                </div>
            </div>
            ))}
        </div>}
          </div>
        </div>
      </div> 
    </div>
  )
}

export default ClassRoomList